import type { SanityArticle, SanityHubWithArticles } from '../interfaces'
import { fetchSanityQuery } from './sanityClient'
import type { SanityLanguage } from './sanityLanguage'

// All hubs for a language, each with its ordered list of articles. Documents
// are filtered by the `language` field written by
// @sanity/document-internationalization (one document per language).
// Same GROQ as the arcmosaico prototype.
const HUBS_WITH_ARTICLES_QUERY = `
  *[_type == "hub" && language == $lang] | order(coalesce(order, 9999) asc, title asc) {
    _id,
    title,
    "slug": slug.current,
    description,
    color,
    icon,
    order,
    "articles": *[_type == "article" && language == $lang && hub._ref == ^._id]
      | order(coalesce(order, 9999) asc, title asc) {
        _id,
        title,
        "slug": slug.current,
        excerpt,
        thumbnail,
        order,
        "tags": tags[]->{
          _id,
          title,
          "slug": slug.current
        }
      }
  }
`

// A single article by slug, scoped to a language, with its parent hub.
const ARTICLE_BY_SLUG_QUERY = `
  *[_type == "article" && language == $lang && slug.current == $slug][0] {
    _id,
    title,
    "slug": slug.current,
    excerpt,
    content,
    hub->{
      title,
      "slug": slug.current,
      color,
      icon
    }
  }
`

export const getHubsWithArticles = async (lang: SanityLanguage): Promise<SanityHubWithArticles[]> => {
  return fetchSanityQuery<SanityHubWithArticles[]>(HUBS_WITH_ARTICLES_QUERY, { lang })
}

export const getArticleBySlug = async (slug: string, lang: SanityLanguage): Promise<SanityArticle | null> => {
  return fetchSanityQuery<SanityArticle | null>(ARTICLE_BY_SLUG_QUERY, { slug, lang })
}
